import { render, staticRenderFns } from "./PrivatePurchaseRouter4g.vue?vue&type=template&id=24036636&scoped=true&"
import script from "./PrivatePurchaseRouter4g.vue?vue&type=script&lang=js&"
export * from "./PrivatePurchaseRouter4g.vue?vue&type=script&lang=js&"
import style0 from "./PrivatePurchaseRouter4g.vue?vue&type=style&index=0&id=24036636&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24036636",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/emotivi-v2-web/node_modules/@vue/cli-service/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24036636')) {
      api.createRecord('24036636', component.options)
    } else {
      api.reload('24036636', component.options)
    }
    module.hot.accept("./PrivatePurchaseRouter4g.vue?vue&type=template&id=24036636&scoped=true&", function () {
      api.rerender('24036636', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/PrivatePurchaseRouter4g.vue"
export default component.exports